import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { EuropeanUnionList } from '../../constants/quote';
import { JoveProjectTypeEnum } from '../../enums/common';
import { PRICE_BROKER_COMMISSION_DISCOUNT_KEY, PRICE_BROKER_COMMISSION_KEY, PRICE_BROKER_FEE_KEY, PRICE_UNDERWRITING_FEE_KEY, PRICE_WHOLESALE_BROKER_COMMISSION_DISCOUNT_KEY, PRICE_WHOLESALE_BROKER_COMMISSION_KEY, PRICE_WHOLESALE_BROKER_FEE_KEY } from '../../hooks/useQuotePriceDetailInfo';
import { getLocalTranslation } from '../i18nKit';
export var getInsurancePremiumTaxDisplayText = function getInsurancePremiumTaxDisplayText(country, config) {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  var displayText = (config === null || config === void 0 ? void 0 : config.initialText) || $t('text:insurance_premium_tax');

  if (EuropeanUnionList.includes(country)) {
    if (['IE'].includes(country)) {
      displayText = $t('text:government_levy');
    } else {
      displayText = $t('text:taxes_levies');
    }
  }

  return displayText;
};
export var getInsurancePremiumExcludingIPTDisplayText = function getInsurancePremiumExcludingIPTDisplayText(country, config) {
  var _getLocalTranslation2 = getLocalTranslation(),
      $t = _getLocalTranslation2.$t;

  var displayText = (config === null || config === void 0 ? void 0 : config.initialText) || $t('text:insurance_premium_excl_ipt');

  if (EuropeanUnionList.includes(country)) {
    if (['IE'].includes(country)) {
      displayText = $t('text:insurance_premium_excl_gl');
    } else if (['PT'].includes(country)) {
      displayText = "".concat($t('text:insurance_premium'), " (").concat($t('text:excluding'), " IT)");
    } else {
      displayText = $t('text:insurance_premium_excl_tl');
    }
  }

  return displayText;
};
export var getIncludingIPTDisplayText = function getIncludingIPTDisplayText(country, config) {
  var _getLocalTranslation3 = getLocalTranslation(),
      $t = _getLocalTranslation3.$t;

  var displayText = (config === null || config === void 0 ? void 0 : config.initialText) || $t('text:including_ipt');

  if (EuropeanUnionList.includes(country)) {
    if (['IE'].includes(country)) {
      displayText = $t('text:including_gl');
    } else if (['PT'].includes(country)) {
      displayText = "".concat($t('text:including'), " IT");
    } else {
      displayText = $t('text:including_tl');
    }
  }

  return displayText;
};
export var getAdminFeeDisplayText = function getAdminFeeDisplayText(country, config) {
  var _getLocalTranslation4 = getLocalTranslation(),
      $t = _getLocalTranslation4.$t;

  return (config === null || config === void 0 ? void 0 : config.initialText) || $t('text:admin_fee');
};
export var getProcessingDisplayText = function getProcessingDisplayText(country, config) {
  var _getLocalTranslation5 = getLocalTranslation(),
      $t = _getLocalTranslation5.$t;

  return (config === null || config === void 0 ? void 0 : config.initialText) || $t('text:processing_fee');
};
export var getUnderwritingFeeDisplayText = function getUnderwritingFeeDisplayText(country, config) {
  var _getLocalTranslation6 = getLocalTranslation(),
      $t = _getLocalTranslation6.$t;

  return (config === null || config === void 0 ? void 0 : config.initialText) || $t('text:underwriting_fee');
};
export var getTotalPayableDisplayText = function getTotalPayableDisplayText(country, config) {
  var _getLocalTranslation7 = getLocalTranslation(),
      $t = _getLocalTranslation7.$t;

  return (config === null || config === void 0 ? void 0 : config.initialText) || $t('text:total_payable');
};
export var getExclELDisplayText = function getExclELDisplayText(country, config) {
  var _getLocalTranslation8 = getLocalTranslation(),
      $t = _getLocalTranslation8.$t;

  var displayText = (config === null || config === void 0 ? void 0 : config.initialText) || "".concat($t('page:bottomPrice.excl'), ". EL");

  if (EuropeanUnionList.includes(country)) {
    if (['PT'].includes(country)) {
      displayText = "".concat($t('page:bottomPrice.excl'), ". RE");
    }
  }

  return displayText;
};
export var getTotalFeesDisplayText = function getTotalFeesDisplayText(country, config) {
  var _getLocalTranslation9 = getLocalTranslation(),
      $t = _getLocalTranslation9.$t;

  return (config === null || config === void 0 ? void 0 : config.initialText) || 'Fees';
};
export var getTotalDiscountDisplayText = function getTotalDiscountDisplayText(country, config) {
  var _getLocalTranslation10 = getLocalTranslation(),
      $t = _getLocalTranslation10.$t;

  return (config === null || config === void 0 ? void 0 : config.initialText) || $t('kit:quotes.discount');
};
export var getBrokerCommissionDisplayText = function getBrokerCommissionDisplayText(country, config) {
  var _ref = config || {},
      isWholeSaleBrokerVisit = _ref.isWholeSaleBrokerVisit,
      isMasterPromotionQuote = _ref.isMasterPromotionQuote,
      isPartnerQuote = _ref.isPartnerQuote,
      haveWholeSaleBrokerCommissionValue = _ref.haveWholeSaleBrokerCommissionValue;

  var showParentValue = isWholeSaleBrokerVisit && !isMasterPromotionQuote;

  var _getLocalTranslation11 = getLocalTranslation(),
      $t = _getLocalTranslation11.$t;

  var displayText = '';

  if ([PRICE_WHOLESALE_BROKER_COMMISSION_KEY].includes(config === null || config === void 0 ? void 0 : config.priceKey)) {
    displayText = 'Wholesale Broker commission';
  }

  if ([PRICE_BROKER_COMMISSION_KEY].includes(config === null || config === void 0 ? void 0 : config.priceKey)) {
    if (isPartnerQuote) {
      displayText = $t('kit:partners.partner_referral_fee');
    } else {
      displayText = showParentValue ? haveWholeSaleBrokerCommissionValue ? 'o/w Sub-broker commission' : 'Sub-broker commission' : isMasterPromotionQuote ? $t('kit:quotes.broker_commission') : 'Sub-broker commission';
    }
  }

  return displayText || (config === null || config === void 0 ? void 0 : config.initialText) || $t('kit:quotes.broker_commission');
};
export var getBrokerCommissionDiscountDisplayText = function getBrokerCommissionDiscountDisplayText(country, config) {
  var _ref2 = config || {},
      isWholeSaleBrokerVisit = _ref2.isWholeSaleBrokerVisit,
      isMasterPromotionQuote = _ref2.isMasterPromotionQuote,
      isPartnerQuote = _ref2.isPartnerQuote;

  var showParentValue = isWholeSaleBrokerVisit && !isMasterPromotionQuote;

  var _getLocalTranslation12 = getLocalTranslation(),
      $t = _getLocalTranslation12.$t;

  var displayText = '';

  if ([PRICE_WHOLESALE_BROKER_COMMISSION_DISCOUNT_KEY].includes(config === null || config === void 0 ? void 0 : config.priceKey)) {
    displayText = 'Wholesale Broker commission discount';
  }

  if ([PRICE_BROKER_COMMISSION_DISCOUNT_KEY].includes(config === null || config === void 0 ? void 0 : config.priceKey)) {
    if (isPartnerQuote) {
      displayText = 'Partner referral fee discount';
    } else {
      displayText = showParentValue ? 'Sub-broker commission discount' : isMasterPromotionQuote ? $t('kit:quotes.broker_commission_discount') : 'Sub-broker commission discount';
    }
  }

  return displayText || (config === null || config === void 0 ? void 0 : config.initialText) || $t('kit:quotes.broker_commission_discount');
};
export var getBrokerFeeDisplayText = function getBrokerFeeDisplayText(country, config) {
  var _ref3 = config || {},
      isWholeSaleBrokerVisit = _ref3.isWholeSaleBrokerVisit,
      isMasterPromotionQuote = _ref3.isMasterPromotionQuote,
      isPartnerQuote = _ref3.isPartnerQuote;

  var showParentValue = isWholeSaleBrokerVisit && !isMasterPromotionQuote;

  var _getLocalTranslation13 = getLocalTranslation(),
      $t = _getLocalTranslation13.$t;

  var displayText = '';

  if ([PRICE_WHOLESALE_BROKER_FEE_KEY].includes(config === null || config === void 0 ? void 0 : config.priceKey)) {
    displayText = 'Wholesale Broker fee';
  }

  if ([PRICE_BROKER_FEE_KEY].includes(config === null || config === void 0 ? void 0 : config.priceKey)) {
    if (isPartnerQuote) {
      displayText = $t('kit:partners.partner_fee');
    } else {
      if ([JoveProjectTypeEnum.cms].includes(config === null || config === void 0 ? void 0 : config.projectSource)) {
        displayText = showParentValue ? 'Sub-broker fee' : isMasterPromotionQuote ? $t('kit:quotes.broker_fee') : 'Sub-broker fee';
      } else {
        displayText = $t('kit:quotes.broker_fee');
      }
    }
  }

  return displayText || (config === null || config === void 0 ? void 0 : config.initialText) || $t('kit:quotes.broker_fee');
};
export var getQuotePriceIntroductionTextInfo = function getQuotePriceIntroductionTextInfo(config) {
  var _priceIntroductionTex;

  var priceIntroductionTextMap = (_priceIntroductionTex = {}, _defineProperty(_priceIntroductionTex, PRICE_WHOLESALE_BROKER_COMMISSION_KEY, 'This is the share of commission allocated to the wholesale broker in a broker-sub-broker arrangement. It is the broker’s compensation for placing and supporting the policy at the higher brokerage level.'), _defineProperty(_priceIntroductionTex, PRICE_BROKER_COMMISSION_KEY, 'This is the commission allocated to the sub-broker. It is the sub-broker’s compensation for arranging the policy and servicing the client relationship.'), _defineProperty(_priceIntroductionTex, PRICE_WHOLESALE_BROKER_COMMISSION_DISCOUNT_KEY, 'This is a reduction taken from the wholesale broker commission before it is paid out. For example, if the commission is 15% and the discount is 7%, the remaining commission becomes 8%.'), _defineProperty(_priceIntroductionTex, PRICE_BROKER_COMMISSION_DISCOUNT_KEY, 'This is a reduction taken from the sub-broker commission before it is paid out. It lowers the commission amount, but it does not change the underlying insurance premium.'), _defineProperty(_priceIntroductionTex, PRICE_WHOLESALE_BROKER_FEE_KEY, 'This is an additional service or administration fee charged by the wholesale broker for overseeing the placement and handling of the policy.'), _defineProperty(_priceIntroductionTex, PRICE_BROKER_FEE_KEY, 'This is an additional service or administration fee charged by the sub-broker for arranging and managing the policy.'), _defineProperty(_priceIntroductionTex, PRICE_UNDERWRITING_FEE_KEY, 'This is a fee charged for underwriting review, risk assessment, and policy setup or issuance.'), _priceIntroductionTex);
  return config !== null && config !== void 0 && config.isPartnerQuote ? '' : priceIntroductionTextMap[config === null || config === void 0 ? void 0 : config.priceKey] || '';
};